import { GreenroomTokenResponse } from '@/types/greenroom/profile.types';
import { Get } from '../helpers';

const GetGreenroomUserToken = async (): Promise<GreenroomTokenResponse> => {
  return Get({
    url: `${import.meta.env.VITE_GREENROOM_API}/v2/greenroom/auth/profile`,
    headers: {
      'Content-Type': 'application/json',
      'bl-global-resource': 'false',
    },
  });
};

export default GetGreenroomUserToken;
